// extracted by mini-css-extract-plugin
export default {"main":"UserProfileVer2_main__mbdvO","loader":"UserProfileVer2_loader__bpUxp","title-section":"UserProfileVer2_title-section__5HNM3"};